<template>
  <div class="wrapper w-mb2" v-if="!!block.data.text">
    <figure>
      <blockquote class="blockquote" :class="{ tac: block.data.alignment == 'center' }">
        <p>{{ block.data.text }}</p>
      </blockquote>
      <figcaption class="blockquote-footer" v-if="!!block.data.caption">
        {{ block.data.caption }}
      </figcaption>
    </figure>
  </div>
</template>
<script>
export default {
  name: "QuoteBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
figure {
  margin: 0;
  .blockquote {
    margin: 0 0 1rem;
    font-size: 1.25rem;

    & > :last-child {
      margin-bottom: 0;
    }

    p {
      margin-bottom: 0;
    }
  }
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;

  &::before {
    content: "— ";
  }
}
</style>
